
import { LocalDictionaryFactory } from '../../../api/api.module'

//#region Service Imports

import { DATA_TYPE_FORMAT_SERVICE_NAME, DataTypeFormatService } from '../../../../services/data-type'
import { $SCOPE_SERVICE_NAME, $ELEMENT_SERVICE_NAME, $Q_SERVICE_NAME, $TIMEOUT_SERVICE_NAME } from '../../../../services/system'
import { USER_SESSION_SERVICE_NAME, UserSessionService } from '../../../../services/user-session'

//#endregion

import { ChartDirectiveController } from './chart.directive.controller'

//#region Asset Imports

import * as TEMPLATE from './chart.tpl.html'

//#endregion

export class MeasurementsChartDirective implements ng.IDirective {
    scope = {
        "source": "=",
        "groups": "=",
        "devices": "=",
        "meters": "=",
        "showAllSeries": "="
    }
    controller = [
        $SCOPE_SERVICE_NAME,
        $ELEMENT_SERVICE_NAME,
        '$filter',
        $Q_SERVICE_NAME,
        $TIMEOUT_SERVICE_NAME,
        'localDictionary',
        DATA_TYPE_FORMAT_SERVICE_NAME,
        USER_SESSION_SERVICE_NAME,
        (
            $scope,
            $element: JQuery,
            $filter: ng.IFilterService,
            $q: ng.IQService,
            $timeout: ng.ITimeoutService,
            localDictionary: LocalDictionaryFactory,
            dataTypeFormatService: DataTypeFormatService,
            userSessionService: UserSessionService
        ) => new ChartDirectiveController($scope, $element, $filter, $q, $timeout, localDictionary, dataTypeFormatService, userSessionService)
    ]
    template = TEMPLATE
    restrict = 'E'
    replace = true
}